"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What does Evermark produce for arc flash labeling?",
  answer: "Evermark Industrial Solutions produces the physical arc flash labels — engraved or printed, stock or custom — from the data in your arc flash study. Evermark manufactures the label; it does not perform the study or determine the hazard values."
}, {
  question: "Does Evermark perform arc flash studies or calculate incident energy?",
  answer: "No. Evermark Industrial Solutions does not perform arc flash studies, calculate incident energy, determine boundaries, or select PPE — those are engineering determinations made by a qualified person under NFPA 70E and IEEE 1584. Evermark produces labels from the study's results."
}, {
  question: "What information is required on an arc flash label?",
  answer: "An arc flash label commonly shows nominal voltage, arc flash boundary, incident energy with working distance (or PPE category), required PPE, equipment ID, and the analysis date; exact required content depends on the NFPA 70E edition adopted and the facility's program, which Evermark recommends confirming with the qualified person."
}, {
  question: "How long do arc flash labels last, and how often are they updated?",
  answer: "Durability depends on material and environment; engraved phenolic and metal labels are built for long permanent service, while studies and labels are commonly reviewed on about a five-year cycle and after system changes under NFPA 70E. Evermark Industrial Solutions produces replacement labels from updated study data."
}, {
  question: "Can Evermark match our existing label format or template?",
  answer: "Yes — Evermark Industrial Solutions produces custom arc flash labels to your layout, fields, and submittal template, confirmed on a proof before production."
}, {
  question: "What's the lead time for arc flash label printing?",
  answer: "Depends on construction, quantity, and data format; standard and rush options are quoted per job — use {{verify: standard lead time}}, do not invent a number."
}];
export default function ArcFlashLabelsCommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="arc-flash-labels-common-questions" className="bg-popover text-popover-foreground py-16 md:py-24 px-6">
      <div ref={ref} className={`mx-auto max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight">
            Arc Flash Labels — Common Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="font-default text-left text-base md:text-lg font-semibold hover:text-primary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}